import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  Tv as TvIcon,
  CalendarToday as CalendarIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';

const DALSProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/TV/DALS.png"
          alt="Logo Danse avec les Stars"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Danse avec les Stars
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2019-2020
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Mission de maintenance et support technique sur l'émission "Danse avec les Stars". 
        Responsabilité de la maintenance des systèmes de notation jury (boitiers de vote) 
        et de vote public (téléphone). Participation active aux émissions en tant qu'opérateur 
        spare pour assurer la redondance et la continuité du système principal.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Missions réalisées */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Missions réalisées
        </Typography>
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, 
          gap: 2 
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Maintenance système notation jury
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Maintenance système vote public
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Gestion boitiers de vote
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Opérateur spare en direct
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Monitoring temps réel
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Intervention d'urgence
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Technologies (générales) */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Domaines techniques
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Systèmes de vote', 'Redondance système', 'Support plateau', 'Monitoring temps réel'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Défis techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold' 
          }}
        >
          Défis techniques relevés
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Double système de vote :</strong> Maintenir simultanément les systèmes 
          de notation jury (boitiers) avec des contraintes 
          de timing strictes et une fiabilité absolue.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Redondance critique :</strong> Assurer une continuité de service 
          parfaite en tant qu'opérateur spare, avec des procédures de basculement 
          instantané en cas de défaillance du système principal.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Contraintes temps réel :</strong> Gérer les votes en direct et validation immédiate des résultats.
        </Typography>
        <Typography variant="body2">
          <strong>Pression plateau :</strong> Intervention technique en direct devant 
          des millions de téléspectateurs, avec une tolérance zéro aux dysfonctionnements 
          pendant les phases de vote cruciales.
        </Typography>
      </Box>
    </Box>
  );
};

export default DALSProject;
